'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { Heading } from '@/components/ui/heading'
import { Eyebrow } from '@/components/Eyebrow'
import { Text } from '@/components/ui/text'
import { WhyBlock } from '@/payload-types'

export function WhyClient({ heading, reasons }: WhyBlock) {
  return (
    <Section bgClassName="bg-paper-2">
      <div className="flex flex-col lg:flex-row justify-between gap-[80px]">
        <div className="lg:max-w-[300px]">
          <Heading size="h2" className="text-dark">
            {heading}
          </Heading>
        </div>
        <div className="flex-1 grid grid-cols-1 xl:grid-cols-1 2xl:grid-cols-3 gap-x-8 gap-y-16">
          {reasons.map((reason) => (
            <div key={reason.number} className="flex flex-col gap-[50px]">
              <Eyebrow label={`REASON ${reason.number}`} color="highlighter" variant="dark" />
              <Text size="xl" className="text-dark">
                {reason.description}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </Section>
  )
}
